import React from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faList, faSliders, faTableList, faTags } from '@fortawesome/free-solid-svg-icons'
import MenuLayout from "./MenuLayout"
import { RouteInfoType } from "../../types/types";


import MenuListPage from "./pages/menusList/MenusList";
import MenuEditorPage from "./pages/menuEditor/MenuEditor";
import ModifierSetsPage from "./pages/modifierSets";
import MenuItemBadgesPage from "./pages/menuItemBadges";
import StopListPage from "./pages/stopList/StopListPage";
import EditMenuItemPage from "./pages/menuEditor/EditMenuItemPage";
import TablesManagementPage from "./pages/tables/index";
import MenuSettingsPage from "./pages/menuSettings/MenuSettingsPage";
import IikoIntegrationPage from "./pages/iikoIntegration/IikoIntegrationPage";
import { IconProp } from "@fortawesome/fontawesome-svg-core";


const menuRoutes = [
    {
        id: "menus",
        name: "Меню",
        header: "Меню",
        path: "/menus",
        component: MenuLayout,
        nonCollapsable: true,
        icon: <FontAwesomeIcon icon={faList as IconProp} size={"lg"}/>,
        routes: [
            {
                path: "/menus/regular/list",
                name: "Меню",
                component: MenuListPage,
                icon: <FontAwesomeIcon icon={faList as IconProp} size={"lg"}/>,
            },
            {
                path: "/menus/modifiers/list",
                name: "Модификаторы",
                component: ModifierSetsPage,
                icon: <FontAwesomeIcon icon={faSliders as IconProp} size={"lg"}/>,

            },
            {
                path: "/menus/badges/list",
                name: "Бейджи",
                component: MenuItemBadgesPage,
                icon: <FontAwesomeIcon icon={faTags as IconProp} size={"lg"}/>,
            },
            {
                path: "/menus/tables/list",
                name: "Столы",
                component: TablesManagementPage,
                icon: <FontAwesomeIcon icon={faTableList as IconProp} size={"lg"}/>,
            },
            {
                hide: true,
                path: "/menus/modifiers/:modifierId/view",
                name: "",
                component: ModifierSetsPage,

            },
            {
                hide: true,
                path: "/menus/regular/settings/:menuId/iiko",
                name: "Интеграция с iiko",
                component: IikoIntegrationPage
            },
            {
                hide: true,
                path: "/menus/:menuType/settings/:menuId",
                name: "Настройки меню",
                component: MenuSettingsPage
            },
            {
                hide: true,
                path: "/menus/regular/:menuId/view",
                name: "Редактор меню",
                component: MenuEditorPage
            },
            {
                hide: true,
                path: "/menus/regular/:menuId/stoplist",
                name: "Стоп-лист",
                component: StopListPage
            },
            {
                hide: true,
                path: "/menus/regular/:menuId/:categoryId/:menuItemId",
                name: "Редактирование пункта меню",
                component: EditMenuItemPage
            },
        ]
    }
]

export default menuRoutes as RouteInfoType[];
